import { IntlShape } from 'react-intl';
import { ISimpleSelectOption } from '../../Forms/ArrayFields/interfaces';

export type AreaRefueling = {
  refueling: {
    type: string;
    fuels: {
      fuelTypeId: number;
      name: string;
      unitPriceIncVat: number;
      currency: string;
      unit: string;
    }[];
  };
};

export type IWaypointListResponseData = AreaRefueling & {
  id: number;
  name: string;
  type: number;
  coordinates: any;
  centerPoint: any;
  customerId: number;
  icon: string | null;
  categoryName: string | null;
  customerLabel: string;
  waypoint: boolean;
};

export interface IWaypointListResponse {
  status: string;
  userSettingsKey: string;
  paging: any;
  sorting: any;
  columns: any;
  actions: any;
  records: IWaypointListResponseData[];
}

export interface IWaypointAddResponseData {
  id: number;
  customerId: number;
  name: string;
  type: number;
  coordinates: any;
  centerPoint: any;
  createdBy: number;
  createdAt: string;
  modifiedBy: number | null;
  modifiedAt: string | null;
  deletedBy: number | null;
  deletedAt: string | null;
}

export interface IAddWaypointRequestData {
  name: string;
  type: number | string;
  centerPoint?: any;
  typeName?: string;
  coordinates: any;
  area: number;
  customerId: number;
  categoryId: number;
  additionalInfo?: any;
  icon?: any;
  color?: any;
  refueling?: {
    type: string;
    fuels: {
      fuelTypeId: number;
      unitPriceIncVat: number;
    }[];
  };
  waypoint: boolean;
}

export interface IWaypointAlarmDetails {
  alarmId: string;
  name: string;
}

export interface IVerifyDeleteDetail {
  details: IWaypointAlarmDetails[];
  message: string;
  total: number;
  type: string;
}

export interface IVerifyDeleteRequestData {
  details: IVerifyDeleteDetail[];
  references: number;
}

export interface ICategoryWaypoint {
  id: number;
  name: string;
  icon: string;
}

export type RefuelingAreaType = 'commercial' | 'private';

export type IDetailWaypointResponseData = AreaRefueling & {
  area: number;
  category: ICategoryWaypoint | null;
  categoryId: number;
  centerPoint: IWaypointPostion | null;
  coordinates?: IWaypointPostion[];
  customerId: number;
  name: string;
  type: string;
  typeName: string;
  createdByName?: string;
  createdAt?: string;
  modifiedByName?: string | null;
  modifiedAt?: string | null;
  customerName?: string;
  customerLabel?: string;
  waypoint: boolean;
};

export interface ICategoryIdValues {
  value: number;
  icon: string;
  item: string;
}

export interface ICategoryIdWaypoint {
  values: ISimpleSelectOption[];
}

export interface ICustomerIdWaypoint {
  values: ISimpleSelectOption[];
}

export interface ITypeValues {
  value: string;
  item: string;
}

export interface ITypeWaypoint {
  values: ITypeValues[];
}

export interface IFormWaypointResponseData {
  categoryId: ICategoryIdWaypoint;
  customerId: ICustomerIdWaypoint;
  type: ITypeWaypoint;
  fuelTypeList: ITypeValues[];
  refuelingTypeList: ITypeValues[];
}
export type AreaFilterOptions = {
  categoryId: ITypeValues[];
  customerId: ITypeValues[];
  type: ITypeValues[];
  areaType: ITypeValues[];
  refuelingTypeList: ITypeValues[];
};

export type FuelFilterArea = {
  refueling?: boolean;
  waypoint?: boolean;
  refuelingAreaType?: RefuelingType;
};

export type IFiltersWaypoint = FuelFilterArea & {
  categoryId?: number;
  customerId?: number;
  type?: string;
};
export type RefuelingType = 'commercial' | 'private';

export type IWaypoint = AreaRefueling & {
  id?: number;
  name?: string;
  type?: number | string;
  typeName?: string;
  coordinates?: IWaypointPostion[];
  icon?: string | null;
  color?: string | null;
  center?: IWaypointPostion | null;
  categoryId?: number | null;
  customerId?: number;
  area?: number;
  category?: ISimpleSelectOption;
  categoryName?: string | null;
  customerLabel?: string;
  waypoint: boolean;
};

export interface IWaypointPostion {
  latitude: number;
  longitude: number;
}

export interface IWindowArea {
  newWindow: google.maps.OverlayView;
  area: number;
}

const areaTypeOptions = [
  {
    value: 'waypoint',
    item: 'tripsOverview.modal.waypoint',
  },
  {
    value: 'fuelArea',
    item: 'enum.waypoints.area.type.fuel',
  },
  {
    value: 'waypointAndFuelArea',
    item: 'enum.waypoints.area.type.waypointAndFuel',
  },
];
export const translateOptions = (intlShape: IntlShape) => {
  const { formatMessage: f } = intlShape;
  return areaTypeOptions.map((option) => ({
    ...option,
    item: f({ id: option.item }),
  }));
};
export type AreaTypes = 'waypoint' | 'fuelArea' | 'waypointAndFuelArea';
export const WAYPOINT_AREA_TYPE = 'waypoint';
export const FUEL_AREA_TYPE = 'fuelArea';
export const WAYPOINT_AND_FUEL_AREA_TYPE = 'waypointAndFuelArea';
